module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/hairmake_sns_01-de326c10e283b39510d49c764e11606c.jpg";